import React from "react";
import "./styles.scss";
import Card from "./Card.js";
import Order from "../../assets/images/Order.png";
import Result from "../../assets/images/Result.png";
import Visit from "../../assets/images/Visit.png";
const CardList = () => {
  return (
    <div className="CardContainer">
      <Card style={{ display: "flex", justifyContent: "center"}}
        img={Order}
        heading="Choose and Order Tests Online"
        text="Find and compare medical tests from different partners. Choose the one that suits you best in terms of price and turnaround time. Register or Login to place your order and make the payment using our secure payment options."
      />
      <Card
        img={Visit}
        heading="Visit Partner Lab/Have Partner Lab Visit You"
        text="Get your tests done conveniently either at home through our Home service or by visiting the lab. If you choose home sample collection, our partner laboratory will call you within an hour after payment to arrange the sample collection. Remember to bring your payment receipt and a photo ID when visiting the lab."
      />
      <Card
        img={Result}
        heading="Get Your Results"
        text="Access your lab results anytime, anywhere by logging into your private profile. View, save, and even print your results directly from your account."
      />
    </div>
  );
}

export default CardList;
